import {defineComponent} from 'vue';
import {shortkeyStatusbar} from '@/mixins/common/shortkeyStatusbar';
import {mixinSuper} from '@/mixins/common/mixinSuper';
import {ModuleLayout, ModuleContext} from '@/stores/moduleConst';
import {mapState, mapActions, mapGetters} from 'vuex';
import commonFn from '@/commons/commonFunction';
import popupUtil from '@/commons/popupUtil';
import IndexedDB from '@/commons/indexedDB';
import api from '@/apis/report/staticReportPrintAPI';
import {permission} from '@/mixins/common/permission';
import {collectionMonitor} from '@/setup/utilities/monitor';
import layoutApi from '@/apis/system/layoutAPI';
import _ from 'lodash';
import baseBrowserTitlePage from '@/views/base/baseBrowserTitlePage';

export default defineComponent({
  extends: baseBrowserTitlePage,
  name: 'BasePopup',
  mixins: [shortkeyStatusbar, mixinSuper, permission],
  data() {
    var defaultPageSize = this.$store?.state?.dbOption?.dbOptions?.PageSize;
    return {
      /**
       * Mã màn hình hiện tại
       */
      screenCode: '',
      /**
       * Model lưu trữ param
       */
      model: {},

      /**
       * refname control hiển thị dữ liệu: grid/tree
       */
      viewRef: 'viewList',

      /**
       * Các thông tin cấu hình trên grid
       *
       */
      gridInfo: {
        selected: [],
        /**
         * Số lượng bản ghi trên 1 trang
         */
        pageSize: defaultPageSize ?? 20,
      },

      /**
       * Tách riêng request lấy summary ra khỏi hàm lấy paging data
       */ splitLoadRequest: true,

      /**
       * Đang xử lý với server
       */
      loading: false,
      /**
       * column bind lên grid
       */
      columnsBind: [],
    };
  },
  computed: {
    /**
     * Đối tượng hiển thị grid/view
     */
    grid() {
      return this.$refs[this.viewRef];
    },
    /**
     * Chọn nhiều bản ghi
     */
    multiSelected() {
      return this.gridInfo.selected?.length > 1;
    },
    ...mapGetters({
      /**
       * Ngôn ngữ hiện tại
       */
      Culture: ModuleContext + '/Culture',
    }),
    ...mapGetters(ModuleContext, ['Context']),
    /**
     * Đối tượng state của store
     */
    storeState() {
      return this.$store.state[this.module];
    },
    /**
     * Dữ liệu hiển thị
     */
    empty() {
      return this.storeState.empty;
    },
    /**
     * Dữ liệu hiển thị
     */
    items() {
      return this.storeState.items;
    },
    /**
     * loading
     */
    loading() {
      return this.storeState.loading;
    },
    /**
     * Tổng số
     */
    total() {
      return this.storeState.total;
    },
    /**
     * Summary của grid
     */
    summary() {
      return this.storeState.summary;
    },
    /**
     * loading summary
     */
    loadingSummary() {
      return this.storeState.loadingSummary;
    },
  },
  created() {
    const me = this;
    this._gridEvent = {
      loadData: me.loadData,
      changePageSize: me.gridChangePageSize,
      resizeStop: me.onResizeStop,
      filter: me.reload,
      rowDbClick: me.onRowDbClick,
    };
    this._indexDb = new IndexedDB();
  },
  mounted() {
    window._listPopup = this; // TODO: Trong code không dùng cái này (chỉ dùng để debug)
    //load dữ liệu lần đầu
    // this.$nextTick(() => {
    //   this.reload();
    // });
    //init layout
    this.initLayout();
    this.addObserveControl();

    this.show();
  },
  /**
   * Xóa items trong grid khi unmount
   */
  beforeUnmount() {
    if (this.module) {
      return;
    }
    this.$store.dispatch(`${this.module}/clearItem`);
  },
  watch: {
    'gridInfo.pageSize'(newVal, oldVal) {
      const me = this;

      if (newVal !== oldVal) {
        //chuyển paging bar về trang đầu
        if (me.grid && typeof me.grid.setPage === 'function') {
          me.grid.setPage(1);
        } else {
          let param = me.lastParam || {
            skip: 0,
            take: me['gridInfo.pageSize'],
          };

          me.loadData(param);
        }
      }
    },

    loading: function (newVal) {
      if (newVal) {
        this.$ms.commonFn.mask();
      } else {
        this.$ms.commonFn.unmask();
      }
    },
  },
  methods: {
    ...mapActions({
      loadApplyLayout: ModuleLayout + '/loadApply',
    }),
    /**
     * Đẩy dữ liệu lên monitor
     * @param {*} command
     */
    pushTrans(command) {
      const {pushTrans} = collectionMonitor();
      pushTrans(command, this._formName || this.screenCode, this.module || this.screenCode);
    },
    beforeOpen(e) {
      const me = this;
      me._popup = me.$vfm.dynamicModals[me.$vfm.dynamicModals.length - 1];
      if (e.ref.params._rawValue) {
        this._formName = e.ref.params._rawValue.name;
        this._report = e.ref.params._rawValue;
        this._formParam = e.ref.params._rawValue;

        // nvtoan2 19/12/2023: Tạo ra 1 cái key để xác định reload báo cáo tại vị trí
        // Cái số nhân kia là số linh tinh thôi, chọn số nào cũng dc
        // this._report.KeyReload = this._report.KeyReload ?? Math.floor(Math.random() * 110720) + '';
        this._report.KeyReload = Math.floor(Math.random() * 110720) + '';
      }
    },
    beforeClose() {
      delete this._formName;
      delete this._report;
      delete this._formParam;
      this.hide();
    },

    /**
     * Đóng form
     */
    hide(callback) {
      const me = this;
      me._suppendClose = true;

      if(!me._popup) {
        me._popup = me.$vfm.dynamicModals[me.$vfm.dynamicModals.length - 1];
      }

      me._popup.value = false;

      me.$nextTick(() => {
        me._suppendClose = true;
        delete me._popup;
        if (callback && typeof callback == 'function') {
          callback();
        }
      });
    },

    /**
     * Khởi tạo observe control
     * NCPHUOC 20/04/2022
     * .ms-validate được thêm vào root khi khai báo rules
     */
    addObserveControl() {
      if (!this._observeControls) {
        this._observeControls = [];
        const $el = this.$el;
        const $controls = $el.querySelectorAll('.ms-validate');
        if ($controls && $controls.length > 0) {
          $controls.forEach(item => {
            if (typeof item.getVueInstance === 'function') {
              this._observeControls.push(item.getVueInstance());
            }
          });
        }
      }
    },

    /**
     * Hàm validate các control input
     * Hàm này sử dụng component ms-validate
     * để bao ngoài vùng được validate
     * @Chú ý:ref của ms-validate phải là validateObserver
     * Created by LTDAT(18.06.2020)
     */
    validateComponents() {
      const me = this;
      //refs của ms-validate
      let controls = me._observeControls.filter(
        x =>
          x.$el.offsetWidth ||
          x.$el.offsetHeight ||
          x.$el.getClientRects().length ||
          /** Xử lý validate control khi ẩn */
          (Array.isArray(x?.rules) && x.rules?.some(x => x.hide)),
      );
      if (controls.length > 0) {
        const errors = controls.map(x => {
          if (typeof x.validate === 'function') {
            return x.validate();
          }
          return '';
        });
        return !errors.some(x => x);
      }

      return true;
    },

    /**
     * Hàm dùng để focus vào ô lỗi đầu tiên
     * nqhuy1 (2.5.2024)  - lấy về từ baseDetail
     * */
    focusFirstError() {
      const me = this;
      const $el = me.$el;
      const firstErrorEl = $el.querySelector('.ms-editor .error input,textarea');
      if (firstErrorEl) {
        firstErrorEl.focus();
      }
    },

    /**
     * focus vào control đầu tiên
     */
    focusFirstControl() {
      setTimeout(() => {
        this.$nextTick(() => {
          this.$ms.commonFn.focusFirstControlInput(this.$el);
        });
      }, 300);
    },

    /**
     * Thay đổi pagesize
     */
    gridChangePageSize(value) {
      this.gridInfo.pageSize = value;
    },

    /**
     * Thực hiện load data
     * HTHIEP 04.05.2022
     */
    async show() {},

    /**
     * Hàm xử lý action dbClickRow
     * NNLINH 04.07.2022
     */
    onRowDbClick(row) {},
    /**
     * Xử lý khi dừng resize cột trong grid thì lưu lại config layout
     */
    async onResizeStop(columns) {
      //Xử lý lưu luôn vào db
      try {
        let me = this;

        if (!me.layoutTag) {
          return;
        }
        //Lấy thông tin layout
        let layout = await me.loadApplyLayout(me.layoutTag);
        if (!layout) {
          return;
        }
        if (columns && Array.isArray(columns) && columns.length > 0) {
          layout.config = JSON.stringify(columns);
        }
        //Lấy thông tin user
        const data = me.$store.getters['context/Context'];
        layout.user_id = data?.UserID;
        //Lưu layout mới vào db
        me.setCacheLayoutTemplate(layout);
        await layoutApi.replace(layout);
      } catch (error) {}
    },
    /**
     * Xử lý cấu hình load layout cho grid
     */
    initLayout() {
      const me = this;
      if (me.layoutTag) {
        let layout = me.getCacheLayoutTemplate();

        if (!layout || process.env.NODE_ENV === 'development') {
          me.loadApplyLayout(me.layoutTag).then(layout => {
            //set cache
            me.setCacheLayoutTemplate(layout);

            me.applyLayout(layout);
          });
        } else {
          me.applyLayout(layout);
        }
      }
    },
    /**
     * lấy mẫu layout từ cache
     */
    getCacheLayoutTemplate() {
      const me = this;
      try {
        let layoutTemplate;
        let cacheKey = me.getCacheLayoutTemplateKey();
        if (cacheKey) {
          // let cacheData = await me.$ms.indexedDB.get(cacheKey);
          let cacheData = me.$ms.commonFn.getSessionStorage(cacheKey);
          if (cacheData) {
            layoutTemplate = JSON.parse(cacheData);
          }
        }
        return layoutTemplate;
      } catch (ex) {
        console.error(ex);
      }
      return null;
    },
    /**
     * lưu cache mẫu layout
     */
    setCacheLayoutTemplate(layout) {
      const me = this;
      let cacheKey = me.getCacheLayoutTemplateKey();
      if (cacheKey) {
        // let cacheData = await me.$ms.indexedDB.get(cacheKey);
        me.$ms.commonFn.setSessionStorage(cacheKey, JSON.stringify(layout));
      }
    },
    /**
     * lấy cache key mẫu layout
     */
    getCacheLayoutTemplateKey() {
      const me = this;
      let cacheKey = '';
      if (me.Context && me.Context.UserID && me.layoutTag) {
        cacheKey = 'LayoutTemplate_{0}_{1}'.format(me.layoutTag, me.Context.UserID);
      }
      return cacheKey;
    },
    /**
     * Render mẫu
     */
    applyLayout(layout) {
      const me = this;

      me.layout = me.convertToLayoutTemplete(layout);
      me.columnsBind = me.getLayoutColumn(layout, me.layoutTag);
      // custom lại column trước khi load
      me.customColumns(me.columnsBind);

      me.grid.initColumns(me.columnsBind);

      //load dữ liệu lần đầu
      me.$nextTick(() => {
        me.reload();
      });
    },
    customColumns(columns) {},
    convertToLayoutTemplete(layout) {
      let layoutTemplete = {};
      if (layout) {
        layoutTemplete.code = layout.tag;
        layoutTemplete.is_system = layout.is_system;
        layoutTemplete.config = layout.config;
      }
      return Object.assign({}, layoutTemplete);
    },

    /**
     * Lấy thông tin column render từ thông tin của mẫu
     */
    getLayoutColumn(layout, tag) {
      if (layout != undefined) {
        const me = this;
        let columns = JSON.parse(layout.config);

        //nếu là mẫu mặc định và ngôn ngữ khác tiếng việt -> cập nhật caption/title theo ngôn ngữ
        if (layout.is_system) {
          me.localizationColumn(columns, tag);
        }
        //nnlam: orderby lại theo sort_order và lock.
        columns = _(columns)
          .chain()
          .sortBy('sort_order')
          .sortBy(function (column) {
            return !column.lock;
          })
          .value();

        me.customLayoutColumns(columns);

        return columns;
      }
    },

    /**
     * Thực hiện custom columns tùy theo nghiệp vụ
     * @param {*} columns
     * NVTUAN1 03.08.2022
     */
    customLayoutColumns(columns) {},

    /**
     * Xử lý ngôn ngữ cho caption và title của column
     */
    localizationColumn(columns, tag) {
      const me = this,
        culture = me.Culture;

      //nếu là mẫu mặc định và ngôn ngữ khác tiếng việt -> cập nhật caption/title theo ngôn ngữ
      if (culture !== 'vi') {
        let fn = function (column, field, key) {
          let text = me.$ms.commonFn.getColumnText(field, tag);
          if (typeof text !== 'undefined') {
            column[field] = text;
          }
        };

        for (let i = 0; i < columns.length; i++) {
          let col = columns[i];
          fn(col, 'caption', col.dataField);
          fn(col, 'title', col.dataField + 'Title');
        }
      }
    },

    /**
     * Load lại dữ liệu
     */
    reload() {
      const me = this;
      //chuyển paging bar về trang đầu
      if (me.grid && typeof me.grid.setPage === 'function') {
        me.grid.setPage(1);
      }

      //xóa tham số cũ để reload
      delete me.lastParam;
      me.refresh();
    },
    /**
     * Load lại dữ liệu
     */
    refresh() {
      const me = this;
      let param = me.lastParam || {
        skip: 0,
        take: me.gridInfo.pageSize,
      };

      me.loadData(param);
      //load summary
      if (me.splitLoadRequest) {
        me.loadDataSumary(param);
      }
    },

    /**
     * Load summary cho grid danh sách
     */
    loadDataSumary(payload) {
      const me = this;

      //tham số chỗ này đã qua hàm load data dc xử lý rồi
      let param = {};
      for (let i in payload) {
        switch (i) {
          case 'skip':
          case 'take':
          case 'sort':
          case 'ignoreSummary':
            //bỏ qua
            break;
          // case "columns":
          //   //TODO chỗ này sẽ chế lại chỉ lấy các cột có sum thôi
          //   break;
          default:
            param[i] = payload[i];
            break;
        }
      }
      //fix chỉ đọc summary
      param.type = me.$ms.constant.PagingType.Summary;

      //xử lý cột summary
      if (me.grid && Array.isArray(me.grid.columnx)) {
        var sumColumns = [];
        me.grid.columnx.forEach(col => {
          if (col.summaryType) {
            sumColumns.push([col.dataField, col.summaryType].join(':'));
          }
        });

        if (sumColumns.length > 0) {
          param.sumColumns = sumColumns.join(',');
        }
      }

      /**
       * Gọi request load data
       */
      me.requestLoadDataSummary(param);
    },

    /**
     * Gọi request load summary
     */
    requestLoadDataSummary(payload) {
      const me = this;
      if (me.grid && !me.grid.isGridTree) {
        me.$store.dispatch(`${me.module}/loadSummary`, payload);
      }
    },

    /**
     * Load dữ liệu grid
     */
    loadData(payload) {
      const me = this;
      if (me.grid) {
        //nếu là trang đầu build lại tham số, các trang tiếp theo dùng lastParam và chỉ đổi skip
        if (!payload.skip) {
          // dqvinh 5.5.2023 gán lại sort nếu không có
          if (!payload.sort && me.lastParam && me.lastParam.sort) {
            payload.sort = me.lastParam.sort;
          }
          //xử lý các tham số khác
          me.processLoadParameter(payload);

          //chuẩn hóa tham số truyền lên server
          me.nomalizeLoadParameter(payload);
        } else {
          for (let i in me.lastParam) {
            switch (i) {
              case 'sort': //dqvinh 5.5.2023 : gán lại sort khi chuyển trang
                if (!payload[i] && me.lastParam[i]) {
                  payload[i] = me.lastParam[i];
                }
                break;
              case 'skip':
                //bỏ qua
                break;
              default:
                payload[i] = me.lastParam[i];
                break;
            }
          }
        }

        //cache lại tham số để dùng cho xuất khẩu và restore data cho lần sau quay lại
        me.lastParam = payload;

        if (me.splitLoadRequest) {
          //fix chỉ đọc data
          payload.type = me.$ms.constant.PagingType.PageData;
        }

        /**
         * Gọi request load data
         */
        me.requestLoadData(payload);
      }
    },

    /**
     * Xử lý điều kiện lọc với nội dung tìm kiếm
     */
    processLoadParameterSearch(payload) {
      const me = this,
        fields = me.searchFields,
        op = me.$ms.constant.FilterOperator.Contains,
        text = (me.searchText || '').trim();

      if (text && Array.isArray(fields) && fields.length > 0) {
        let filter = {
          Field: fields[0],
          Operator: op,
          Value: text,
        };
        payload.filter.push(filter);

        if (fields.length > 1) {
          filter.Ors = [];
          for (let i = 1; i < fields.length; i++) {
            filter.Ors.push({
              Field: fields[i],
              Operator: op,
              Value: text,
            });
          }
        }
      }
    },

    /**
     * Xử lý tham số load dữ liệu
     */
    processLoadParameter(payload) {
      const me = this;

      //filter
      payload.filter = [];
      if (me.grid.filterable && typeof me.grid.getFilterHeader === 'function') {
        payload.filter = me.grid.getFilterHeader();
      }

      //search text
      me.processLoadParameterSearch(payload);

      //column
      payload.columns = me.processLoadParameterColumn(payload);

      //tham số load dữ liệu
      payload.condition = me.getConditionParameter();

      // nếu grid có cấu hình sort default thì
      if (me.grid.defaultSort && Array.isArray(me.grid.defaultSort)) {
        let listSort = [];
        me.grid.defaultSort.forEach(item => {
          // nếu có sort custom thì nếu trùng với item nào thì loại item đó ra khỏi listSort để không bị trùng
          if (payload.Sort) {
            if (!payload.Sort.contains(item.sortField)) {
              listSort.push(`${item.sortField} ${item.sortType == me.$ms.constant.SortStatus.desc ? 'DESC' : 'ASC'}`);
            }
          } else {
            listSort.push(`${item.sortField} ${item.sortType == me.$ms.constant.SortStatus.desc ? 'DESC' : 'ASC'}`);
          }
        });
        let sortDefault = listSort.length > 0 ? listSort.join(', ') : '';
        let sortCustom = payload.Sort ? payload.Sort : '';
        if (sortCustom && sortDefault) {
          payload.sort = [sortCustom, sortDefault].join(', ');
        } else if (!sortCustom && sortDefault) {
          payload.sort = sortDefault;
        } else if (sortCustom && !sortDefault) {
          payload.sort = sortCustom;
        } else {
          payload.sort = '';
        }
      }

      me.customPayload(payload);
    },

    /**
     * Custom tham số payload trước khi call api
     */
    customPayload(payload) {},

    /**
     * Custom tham số load dữ liệu
     */
    processLoadParameterColumn(payload) {
      const me = this;
      let columns = me.grid.columnx;
      let cols = [];
      if (columns) {
        for (let i = 0; i < columns.length; i++) {
          let col = columns[i];
          if (col.dataField && cols.indexOf(col.dataField) === -1) {
            cols.push(col.dataField);
          }
        }
      }
      if (me.grid.idField) {
        cols.push(me.grid.idField);
      }

      if (me.grid.isGridTree) {
        if (me.grid.parentIdField && cols.indexOf(me.grid.parentIdField) === -1) {
          cols.push(me.grid.parentIdField);
        }
      }
      if (me.alwayTakeColumns && me.alwayTakeColumns.length != 0) {
        /*
         * Cấu hình lấy thêm các cột được cấu hình luôn lấy dữ liệu trên grid
         * pvduy 19/01/2021
         */
        for (let i = 0; i < me.alwayTakeColumns.length; i++) {
          if (!cols.includes(me.alwayTakeColumns[i])) {
            cols.push(me.alwayTakeColumns[i]);
          }
        }
      }
      return cols;
    },

    /**
     * Lấy điều kiện load dữ liệu
     */
    getConditionParameter() {
      const me = this;
      let param = {};
      if (me.condition) {
        for (let i in me.condition) {
          let value = me.condition[i];
          if (value) {
            //date
            if (typeof value.getFullYear === 'function') {
              //nếu tên thuộc tính có từ Time -> lấy full datetime
              //else chỉ lấy date
              if (i.indexOf('Time') > -1) {
                value = moment(value).format('YYYY-MM-DD hh:mm:ss');
              } else {
                value = moment(value).format('YYYY-MM-DD');
              }
            }
          }
          param[i] = value;
        }
      }
      return param;
    },

    /**
     * Chuẩn hóa lại tham số truyền lên server
     */
    nomalizeLoadParameter(payload) {
      const me = this;
      if (!payload.skip) {
        delete payload.skip;
      }

      if (payload.filter && payload.filter.length > 0) {
        //Clear múi giờ trước khi đẩy lên server
        payload.filter.forEach((item, i) => {
          let value = item.value;
          if (value) {
            if (typeof value.getFullYear === 'function') {
              item.value = me.$ms.commonFn.getMoment(value).format('YYYY-MM-DDTHH:mm:ss');
            }
          }
        });

        payload.filter = JSON.stringify(payload.filter);
      } else {
        delete payload.filter;
      }

      if (payload.condition && Object.keys(payload.condition).length > 0) {
        payload.condition = JSON.stringify(payload.condition);
      } else {
        delete payload.condition;
      }

      if (payload.columns && payload.columns.length > 0) {
        payload.columns = payload.columns.join(',');
      } else {
        delete payload.columns;
      }
    },
    /**
     * Gọi request load dữ liệu
     * Modiffied NNLINH 04.07.2022: thêm handleBeforeBinding
     */
    async requestLoadData(payload) {
      const me = this;
      if (me.grid && me.grid.isGridTree) {
        me.$store.dispatch(`${me.module}/loadTree`, {
          columns: payload.columns,
        });
      } else {
        let data = await me.$store.dispatch(`${me.module}/load`, payload);
        me.handleBeforeBinding(data);
      }
    },
    /**
     * Xử lý dữ liệu trước khi bind Data
     */
    handleBeforeBinding(data) {},

    /**
     * Xử lý action trên form
     * HTHIEP 04.05.2022
     * @param {*} command
     */
    commandClick(command) {
      switch (command) {
        case this.$ms.constant.Command.Ok:
          commonFn.mask();
          //Lưu lại params vào index db => load lại lần sau
          this._indexDb.set(this._formName, this.model);
          //Lưu param trên server thực hiện load preview report
          //gọi lưu tham số và mở ra preview
          api
            .saveParamter({...this._report, ...{dataParam: this.model}})
            .then(result => {
              //không ẩn mask để cho popup preview gọi ẩn đi
              popupUtil.show('StaticReportPrintPreview', {
                report: this._report,
                key: result,
              });
              // let link = api.getPrintLink(result);
              // window.open(link);
            })
            .catch(err => {
              commonFn.unmask();
              console.log(err);
              showError(err);
            });
          break;
      }
      this.pushTrans(command);
    },

    /**
     * Hiển thị form chi tiết khi click vào ô (nếu có config linkedForm)
     * HQMINH 18.07.2022
     */
    viewLinkedForm(col, dataRow) {
      const me = this;

      // Lấy tên form tùy theo đặc tính ref_type từng bản ghi(Lấy động)
      let formName = me.getFormDetailName(dataRow);

      if (formName) {
        me.viewIncurredData(dataRow, formName);
      }
    },

    /**
     * Lấy tên form chi tiết theo ref_type
     * @param {*} record  dữ liệu dòng trên grid
     * @returns tên form chi tiết
     * HQMINH 18.07.2022
     */
    getFormDetailName(record) {
      const me = this;
      // lấy tên form detail để show
      let formDetailName = '';
      if (record && record.ref_type) {
        Object.keys(me.$ms.constant.RefTypeMapperDetailName).forEach(item => {
          if (
            (Array.isArray(me.$ms.constant.RefTypeMapperDetailName[item]) &&
              me.$ms.constant.RefTypeMapperDetailName[item].find(x => x == record['ref_type'])) ||
            (Number.isInteger(me.$ms.constant.RefTypeMapperDetailName[item]) &&
              me.$ms.constant.RefTypeMapperDetailName[item] == record['ref_type'])
          ) {
            formDetailName = item;
          }
        });
      } else {
        formDetailName = me.formDetailName;
      }

      if (!formDetailName) {
        console.error('Chưa khai báo tên form chi tiết ở RefTypeMapperDetailName.js');
      }

      return formDetailName;
    },

    /**
     * Xem chứng từ phát sinh
     * HQMINH 18.07.2022
     * Modified by NVTUAN1 12.05.2023: Refactor code để truyền đúng tham số cho popup
     * */
    viewIncurredData(record, formName) {
      const me = this;
      //kiểm tra phân quyền
      me.checkActionPermissionAlert(me.$ms.constant.Permission.View);

      // lấy tham số cho form detail
      let params = me.getDetailParameterIncurredData(formName, this.$ms.constant.FormState.View, record);

      //Thêm callback function khi click xem chứng từ
      if(params.options){
        params.options.callbackFnIncurred = me.callbackFnIncurred;
      }
      else {
        params.options = {
          callbackFnIncurred: me.callbackFnIncurred,
        };
      }

      //Show chi tiết chứng từ phát sinh
      popupUtil.show(formName, params);
    },

    /**
     * Lấy tham số khi mở form chi tiết phát sinh dữ liệu
     * HQMINH 18.07.2022
     * */
    getDetailParameterIncurredData(formName, mode, defaultData) {
      const me = this;

      let param = {
        data: defaultData || null,
      };

      switch (mode) {
        case me.$ms.constant.FormState.Duplicate:
        case me.$ms.constant.FormState.Edit:
        case me.$ms.constant.FormState.View:
          param.id = defaultData?.ref_id;
          break;
      }

      param.mode = mode;

      return param;
    },

    /**
     * Hàm callback khi xem chứng từ
     * NVTUAN1 12.05.2023
     */
    async callbackFnIncurred() {},

    /**
     * Link help
     */
    linkHelp(code, type) {
      type = type || 'mimosa';
      return window._helpLink[type] + window._misaHelp[code];
    },

    /**
     * Hàm xử lý in nội dung kiểm tra
     * NHCUONG 07.02.2023
     * Modifed NHCUONG 27.03.2023: Sửa lại luồng in kiểm tra có từ màn hình Tổng hợp đẩy sang không
     * modifiedBy dtnga3 (29.02.2024) bỏ case  IsFromSummaryView đi, gọi thẳng hàm in luôn
     */
    printAuditReport(typeAudit) {
      const me = this;
      me.$ms.commonFn.mask();
      let report = me.getReportInfo(typeAudit);

      let dataParam = me.reportDataParam(typeAudit);
      this.printDataAuditReport(dataParam, report);
    },

    /**
     * Lấy dữ liệu thông tin báo cáo
     * NHCUONG 07.02.2023
     */
    getReportInfo(typeAudit) {
      return {};
    },

    /**
     * Lấy dữ liệu tham số báo cáo khi không dùng form tham số
     * NHCUONG 07.02.2023
     */
    reportDataParam(typeAudit) {
      return {};
    },

    /**
     * Export kiểm tra báo cáo
     * NHCUONG 10.02.2023
     * Modifed NHCUONG 27.03.2023: Sửa lại luồng export kiểm tra có từ màn hình Tổng hợp đẩy sang không
     * modifiedBy dtnga3 (29.02.2024) bỏ case  IsFromSummaryView đi, gọi thẳng hàm in luôn
     */
    exportAuditReport(typeAudit, item) {
      const me = this;
      me.$ms.commonFn.mask();
      let report = me.getReportInfo(typeAudit);

      let dataParam = me.reportDataParam(typeAudit);
      this.exportDataAuditReport(dataParam, report, item);
    },

    /**
     * Hàm In kiểm tra chứng từ
     * @param {*} dataParam
     * @param {*} report
     * NHCUONG 27.03.2023
     */
    printDataAuditReport(dataParam, report) {
      //Lưu param trên server thực hiện load preview report
      //gọi lưu tham số và mở ra preview
      api
        .saveParamter({...report, ...{dataParam: dataParam}})
        .then(result => {
          //không ẩn mask để cho popup preview gọi ẩn đi
          popupUtil.show('StaticReportPrintPreview', {
            report: report,
            key: result,
          });
        })
        .catch(err => {
          this.$ms.commonFn.unmask();
          console.log(err);
        });
    },

    /**
     * Hàm Xuất excel kiểm tra chứng từ
     * @param {*} dataParam
     * @param {*} report
     * @param {*} item
     * NHCUONG 27.03.2023
     * NHCUONG 20.07.2023: Bỏ dùng hàm download link ở common
     */
    exportDataAuditReport(dataParam, report, item) {
      //Lưu param trên server thực hiện load preview report
      //gọi lưu tham số và mở ra preview
      api
        .saveParamter({...report, ...{dataParam: dataParam}})
        .then(result => {
          //không ẩn mask để cho popup preview gọi ẩn đi
          let link = api.getDownloadink(result, commonFn.removeUnicode(report.reportName), item.type);
          console.log('download', link);
          commonFn.downloadLink(link);
          this.$ms.commonFn.unmask();
        })
        .catch(err => {
          this.$ms.commonFn.unmask();
          console.log(err);
        });
    },
    /**
     * Hàm download excel custom
     * @param {*} link
     * NHCUONG 20.07.2023
     */
    downloadLinkDataAuditReport(link) {
      // location.href = link;
      let a = document.getElementById('adownload');
      a.href = link;
      a.target = '_blank';
      a.click();
    },
    /**
     * Submit các grid đang edit
     * TPNAM 11/05/2023
     */
    submitGridEditor() {
      try {
        const me = this,
          {_gridDetails} = me;
        const submitAction = [];
        if (_gridDetails) {
          for (const key in _gridDetails) {
            //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
            if (Object.hasOwnProperty.call(_gridDetails, key)) {
              const keyRef = _gridDetails[key];
              const $gridRef = me.$refs[keyRef];
              if ($gridRef && typeof $gridRef.submitEditor === 'function') {
                submitAction.push($gridRef.submitEditor());
              }
            }
          }
        }

        return Promise.all(submitAction);
      } catch (error) {
        console.log(error);
      }
    },
  },
});
